import { React, useContext, useEffect, useState } from "react";
import { filterLabels, PeFilterContext } from "../Contexts/PeFilterContext";
import { NavLink, useLocation } from "react-router-dom";
import { TableDataContext } from '../Contexts/TableDataContext';
import moment from 'moment';
import { TableHeaderContext } from "../Contexts/TableHeaderContext";
import FilterTag from './FilterTag';
import CloseButton from "../images/CloseBtn.svg";
import { Popover, Modal, Drawer } from "antd"; // Added Drawer import
import ExpandedTagList from "./FilterTag/ExpandedTagList";
import Constants from "../Constants";
import useModule from "../hooks/useModule";
import routePathSegments from "../routeSegments";

/**
 * The `Tag` function is a React component that renders a list of tags based on the filters applied in
 * the application. Modified to include confirmation before removing all filters only.
 */
const Tag = (props) => {
  const {
    monthPickerValue, setMonthPickerValue,
    refineSearchFilters, setrefineSearchFilters, cfsRemoveFilter, 
    FinancialBasedSelected, RatioBasedSelected, GrowthBasedSelected, 
    groupId, setGroupId, iocPayload,  
  } = useContext(PeFilterContext);
  const { setCurrentPage } = useContext(TableDataContext);
  const { setSelectedPage } = useContext(TableHeaderContext);
  const location = useLocation();
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  let tagList = [];
  const { isCFS } = useModule();

  const { pathname } = useLocation();
  const { primaryMasterId } = useModule();
  const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;
  const pathKey = location.pathname.split("/").slice(0, 3).join("/");
  
  // Custom modal styles with both buttons in gold color and fixed hover text color
  const customModalStyles = {
    okButtonProps: { 
      style: { 
        backgroundColor: '#a07924', 
        borderColor: '#a07924',
        color: '#FFFFFF'
      },
      // Maintain color on hover
      // className: 'hover:text-white'
    },
    cancelButtonProps: { 
      style: { 
        backgroundColor: '#fff', 
        borderColor: '#a07924',
        color: '#000'
      },
      // Maintain color on hover
    }
  };

  // Modified removeFilter to show confirmation only for removeAll
  const removeFilter = (key, id, removeAll, option) => {
    if (removeAll) {
      // Show confirmation dialog only for removeAll
      let filterName = filterLabels[key] || key;
      
      // Use custom CSS for consistent text color
      Modal.confirm({
        title: 'Confirmation',
        content: `Do you want to remove the ${filterName} filter?`,
        okText: 'Yes',
        cancelText: 'No',
        ...customModalStyles,
        // Add global CSS overrides for the modal buttons
        wrapClassName: 'custom-modal-buttons',
        onOk: () => {
          // Proceed with removal if confirmed
          setrefineSearchFilters(prev => ({
            ...prev,
            [pathKey]: {
              ...prev[pathKey],
              [key]: []
            },
            [location.pathname]: {
              ...prev[location.pathname],
              [key]: []
            }
          }));
        }
      });
    } else if(isFromGlobalSearch()){
      setrefineSearchFilters({})
      setMonthPickerValue(Constants.initialMonthRange)
    } else {
      console.log(refineSearchFilters, key, id)
      // For individual filter removals, proceed without confirmation
      setrefineSearchFilters(prev => ({
        ...prev,
        [pathKey]: {
          ...prev[pathKey],
          [key]: prev[pathKey][key]?.filter(data => data?.id !== id)
        },
        [location.pathname]: {
          ...prev[location.pathname],
          [key]: prev[location.pathname][key]?.filter(data => data?.id !== id)
        }
      }));
    }
  };

  const removeSaveFilters = () => {
    location.state = {}; 
    setMonthPickerValue(Constants.initialMonthRange);
    setrefineSearchFilters(() => ({
      [location.pathname]: {},
      [pathKey]: {}
    }))
  }

  const closeIconTag = (id, key) => {
    if (key == "monthRange") {
      setMonthPickerValue(Constants.initialMonthRange);
      setCurrentPage(1);
      setSelectedPage(1);
    }  
  };

  const removeGroup = (id, key) => {
    if (key == "myList") {
      Modal.confirm({
        title: 'Confirmation',
        content: `Do you want to remove this list?`,
        okText: 'Yes',
        cancelText: 'No',
        ...customModalStyles,
        wrapClassName: 'custom-modal-buttons',
        onOk: () => {
          setGroupId({});
          setMonthPickerValue(Constants.initialMonthRange);
          setCurrentPage(1);
          setSelectedPage(1);
        }
      });
    }
  };
{/* MOBILE: Collapsible Filter Drawer */}
  const countActiveFilters = () => {
    let count = 1;
    const pathFilters = { ...refineSearchFilters[pathKey], ...refineSearchFilters[location.pathname] } ?? {};
    Object.values(pathFilters).forEach(filter => {
      if (Array.isArray(filter)) count += filter.length;
    });
    if (groupId?.myList?.length > 0) count++;
    return count;
  };

  const clearAllFilters = () => {
    Modal.confirm({
      title: 'Confirmation',
      content: 'Do you want to clear all filters?',
      okText: 'Yes',
      cancelText: 'No',
      ...customModalStyles,
      wrapClassName: 'custom-modal-buttons',
      onOk: () => {
        setrefineSearchFilters({ [location.pathname]: {}, [pathKey]: {} });
        setGroupId({});
        setMonthPickerValue(Constants.initialMonthRange);
        setCurrentPage(1);
        setSelectedPage(1);
        setMobileDrawerOpen(false);
      }
    });
  };
  
  useEffect(() => {
    if(groupId?.myList?.length > 0) {
      if(groupId?.myList[0]?.group_id != null) {
        setMonthPickerValue(['1998-01-01', moment().endOf("month").format("YYYY-MM-DD")]);
      }
    }
  }, [groupId]);
  console.log(Object.values(refineSearchFilters), "refineSearchFilters in Tag component")

  return (
    <div className={props?.page === "inv_lp" ? "px-4 py-3 " : "px-4 py-3"}>
      <div className="flex justify-between items-start">
        {/* MOBILE: Collapsible Filter Drawer - Show only when filters are applied */}
        {(isCFS ? countActiveFilters() > 0 : Object.keys(refineSearchFilters).length > 0) && <div className="md:hidden flex justify-start items-center gap-2 w-full">
          <button
            onClick={() => setMobileDrawerOpen(true)}
            className="relative  px-2 py-1.5 rounded text-xs font-medium whitespace-nowrap flex items-center gap-1.5"
          >
            <label className="text-[10px] leading-[16px] font-sans_book_body whitespace-nowrap text-[#333333] px-3 py-0.5 flex rounded-md ring-1 ring-gray-400 items-center">
              <p className="p-[2px]">{moment(monthPickerValue[0]).format("MMM YY") + " - " + moment(monthPickerValue[1]).format("MMM YY")}</p>
            </label>
            {countActiveFilters() > 0 && <span className="absolute -top-2 -right-2 bg-[rgb(213,212,208)] text-black w-5 h-5 rounded-full border border-gray-700 text-xs font-bold flex items-center justify-center">{countActiveFilters()}</span>}
          </button>
          {countActiveFilters() > 1 && <button onClick={clearAllFilters} className="text-red-600 text-xs underline whitespace-nowrap">Clear all</button>}
        </div>}

        {/* DESKTOP: Display all tags inline */}
        <div className="hidden md:flex flex-wrap gap-2 w-full">  {primaryMasterId != 5 && !location.pathname.includes(routePathSegments.limited_partners) ?
            <label
              htmlFor=""
              className="text-[10px] leading-[16px] font-sans_book_body whitespace-nowrap text-[#333333] px-4 py-0.5 flex rounded-md ring-1 ring-gray-400 items-center tag-animate"
            >
              <p className="p-[2px]">{moment(monthPickerValue[0]).format("MMM YY") + " - " + moment(monthPickerValue[1]).format("MMM YY")}</p>
              {isFromGlobalSearch() || groupId?.myList?.length > 0 ? <></> :
                <img alt="" src={CloseButton} className="h-3 w-3 ml-3 cursor-pointer" onClick={() => closeIconTag(0, "monthRange")} key={"monthRange"} />}
            </label>
            : null
          }
          
          {groupId?.myList?.length > 0 ? 
            (groupId?.myList?.map((tags) => {
              return (<FilterTag title="My List" subTitle={tags?.name} onRemove={() => removeGroup(tags?.id, "myList")} />)
            }))
            : null
          }
          
          {Object.keys(refineSearchFilters[location.pathname] ?? {}).map((filter) => {
            tagList = refineSearchFilters[location.pathname][filter];
            
            if (filter === "financialFilterRequest" || filter === "ratiosFilterRequest" || filter === "growthFilterRequest") {
              return <>
                {tagList && (filter === "financialFilterRequest" ? FinancialBasedSelected : filter === "growthFilterRequest" ? GrowthBasedSelected : RatioBasedSelected).map((option, i) => {
                  return (
                    <>
                      {filter === 'growthFilterRequest' ?
                        (tagList[option]) && (
                          <FilterTag title={filterLabels[filter]} subTitle={`${option}(${tagList[option] ?? ''} %)`} onRemove={() => cfsRemoveFilter(filter, option)} />)
                        :
                        <FilterTag key={i} title={filterLabels[filter]} subTitle={`${option}(${tagList[option + '_min'] ?? ''} - ${tagList[option + '_max'] ?? ''})`} onRemove={() => cfsRemoveFilter(filter, option)} />
                      }
                    </>
                  )
                })
                }
                {(tagList?.unit) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`In Crores`} onRemove={() => cfsRemoveFilter(filter, 'unit')} />
                }
                {(tagList?.year_match_type) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`${tagList?.year_match_type == 'any' ? 'Any Of' : 'Across All'}`} onRemove={() => cfsRemoveFilter(filter, 'year_match_type')} />
                }
                {(tagList?.cagr) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`CAGR`} onRemove={() => cfsRemoveFilter(filter, 'cagr')} />
                }
              </>
            }
            
            if (tagList?.length <= 3 || filter === "growthPercentage" || filter === "ratioPercentage" || filter === "financialPercentage") {
              if ((tagList?.length ?? 0) === 0) return <></>;
              if (filter === "yearFounded") {
                return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "operator" || filter === "deals_operator") {
                return null; 
              }
              if (filter === "dealRange" || filter === "dealSize") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "fundRange" || filter === "fundSize") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "dealInvestorRange") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "returnMultiple") {
                return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "investorSaleInipo") {
                return <FilterTag subTitle={`${filterLabels[filter]} - ${tagList[0]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "chargeDate" || filter === "chargeAmount") {
                return <FilterTag title={filterLabels[filter]} subTitle={tagList[0]?.name} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "growthPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Growth based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              }
              if (filter === "ratioPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Ratio based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              } 
              if (filter === "financialPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Financial based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              }

              if(filter === "Saved Filter"){
                return tagList?.map((tags) => {
                  return (<FilterTag title="" subTitle={tags?.name} onRemove={() => removeSaveFilters()} />);
                });
              }

              // Handle multiCompanySearch filter
              if(filter === "multiCompanySearch"){
                return tagList?.map((company) => {
                  return (<FilterTag title={filterLabels[filter]} subTitle={company?.name} onRemove={() => removeFilter(filter, company?.id, false)} />);
                });
              }
              
              return tagList?.map((tags) => {
                if (tags.hide === true) {
                  return <></>;
                }
                return (<FilterTag title={tags?.title} subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
              });
            }
            else {
              if ((tagList?.length ?? 0) === 0) return <></>;
              
              return (
                <Popover
                  placement="right"
                  title={filterLabels[filter]}
                  content={
                    <ExpandedTagList
                      tagList={tagList}
                      onRemove={(id, removeAll) => removeFilter(filter, id, removeAll)}
                    />
                  }
                >
                  <span>
                    <FilterTag 
                      title={filterLabels[filter]} 
                      subTitle={`${tagList[0]?.name} +${tagList?.length - 1} more`} 
                      onRemove={() => removeFilter(filter, 0, true)} 
                    />
                  </span>
                </Popover>
              );
            }
          })}        
          {(location.pathname.includes("/pe") || location.pathname.includes("/vc") || location.pathname.includes("/re")) && Object.keys(refineSearchFilters[pathKey] ?? {}).map((filter) => {
            tagList = refineSearchFilters[pathKey][filter];
            
            if (filter === "financialFilterRequest" || filter === "ratiosFilterRequest" || filter === "growthFilterRequest") {
              return <>
                {tagList && (filter === "financialFilterRequest" ? FinancialBasedSelected : filter === "growthFilterRequest" ? GrowthBasedSelected : RatioBasedSelected).map((option, i) => {
                  return (
                    <>
                      {filter === 'growthFilterRequest' ?
                        (tagList[option]) && (
                          <FilterTag title={filterLabels[filter]} subTitle={`${option}(${tagList[option] ?? ''} %)`} onRemove={() => cfsRemoveFilter(filter, option)} />)
                        :
                        <FilterTag key={i} title={filterLabels[filter]} subTitle={`${option}(${tagList[option + '_min'] ?? ''} - ${tagList[option + '_max'] ?? ''})`} onRemove={() => cfsRemoveFilter(filter, option)} />
                      }
                    </>
                  )
                })
                }
                {(tagList?.unit) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`In Crores`} onRemove={() => cfsRemoveFilter(filter, 'unit')} />
                }
                {(tagList?.year_match_type) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`${tagList?.year_match_type == 'any' ? 'Any Of' : 'Across All'}`} onRemove={() => cfsRemoveFilter(filter, 'year_match_type')} />
                }
                {(tagList?.cagr) &&
                  <FilterTag title={filterLabels[filter]} subTitle={`CAGR`} onRemove={() => cfsRemoveFilter(filter, 'cagr')} />
                }
              </>
            }
            
            if (tagList?.length <= 3 || filter === "growthPercentage" || filter === "ratioPercentage" || filter === "financialPercentage") {
              if ((tagList?.length ?? 0) === 0) return <></>;
              if (filter === "yearFounded") {
                return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "operator" || filter === "deals_operator") {
                return null; 
              }
              if (filter === "dealRange" || filter === "dealSize") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "fundRange" || filter === "fundSize") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "dealInvestorRange") {
                return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "returnMultiple") {
                return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "investorSaleInipo") {
                return <FilterTag subTitle={`${filterLabels[filter]} - ${tagList[0]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "chargeDate" || filter === "chargeAmount") {
                return <FilterTag title={filterLabels[filter]} subTitle={tagList[0]?.name} onRemove={() => removeFilter(filter, 0, true)} />;
              }
              if (filter === "growthPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Growth based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              }
              if (filter === "ratioPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Ratio based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              } 
              if (filter === "financialPercentage") {
                return tagList?.map((tags) => {
                  return (<FilterTag title="Financial based" subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
                });
              }
              
              return tagList?.map((tags) => {
                if (tags.hide === true) {
                  return <></>;
                }
                return (<FilterTag title={tags?.title} subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
              });
            }
            else {
              if ((tagList?.length ?? 0) === 0) return <></>;
              
              return (
                <Popover
                  placement="right"
                  title={filterLabels[filter]}
                  content={
                    <ExpandedTagList
                      tagList={tagList}
                      onRemove={(id, removeAll) => removeFilter(filter, id, removeAll)}
                    />
                  }
                >
                  <span>
                    <FilterTag 
                      title={filterLabels[filter]} 
                      subTitle={`${tagList[0]?.name} +${tagList?.length - 1} more`} 
                      onRemove={() => removeFilter(filter, 0, true)} 
                    />
                  </span>
                </Popover>
              );
            }
          })}        
        </div>
        {/* /* props?.menu === "cfs" && iocPayload && Object.values(iocPayload).some(
          value => value !== undefined && value !== null && value !== '' && !(Array.isArray(value) && value.length === 0)
        )  */}
        {/* {
        location.pathname.includes('/cfs') &&  !location.pathname.includes('/ioc') && !groupId?.myList?.length > 0 
        ? (
          <div className="ml-4 flex-shrink-0">
            <NavLink
              to={"ioc"} state={{ iocPayload: iocPayload }}
              onClick={() => setGroupId({})}
            >
              <button
                type="submit"
                className="bg-[#BC8B20] px-2 h-[28px] text-[#FFFFFF] rounded-[5px] text-[14px] leading-[17px] whitespace-nowrap"
              >
                Index of charges 
              </button>
            </NavLink>
          </div>
        ) : null} */}
      </div>

      {/* MOBILE DRAWER: Filter Management */}
      <Drawer
        title={<div className="flex justify-between items-center"><span>Active Filters</span><button onClick={clearAllFilters} className="text-red-600 text-[10px] underline">Clear all</button></div>}
        placement="bottom"
        onClose={() => setMobileDrawerOpen(false)}
        open={mobileDrawerOpen}
        height="auto"
        className="mobile-filter-drawer"
      >
        <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto p-[1px]">
          {primaryMasterId != 5 && !location.pathname.includes(routePathSegments.limited_partners) ?
            <label className="text-[10px] leading-[16px] font-sans_book_body whitespace-nowrap text-[#333333] px-3 py-0.5 flex rounded-md ring-1 ring-gray-400 items-center">
              <p className="p-[2px]">{moment(monthPickerValue[0]).format("MMM YY") + " - " + moment(monthPickerValue[1]).format("MMM YY")}</p>
              {isFromGlobalSearch() || groupId?.myList?.length > 0 ? <></> :
                <img alt="" src={CloseButton} className="h-3 w-3 ml-3 cursor-pointer" onClick={() => closeIconTag(0, "monthRange")} />}
            </label>
            : null
          }
          {groupId?.myList?.length > 0 && groupId?.myList?.map((tags) => <FilterTag title="My List" subTitle={tags?.name} onRemove={() => removeGroup(tags?.id, "myList")} />)}
          {Object.keys(refineSearchFilters[location.pathname] ?? {}).map((filter) => {
            tagList = refineSearchFilters[location.pathname][filter];
            if ((tagList?.length ?? 0) === 0) return <></>;
            if (filter === "operator" || filter === "deals_operator") return null;
            if (filter === "yearFounded") return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "dealRange" || filter === "dealSize") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "fundRange" || filter === "fundSize") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "dealInvestorRange") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "returnMultiple") return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "investorSaleInipo") return <FilterTag subTitle={`${filterLabels[filter]} - ${tagList[0]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "chargeDate" || filter === "chargeAmount") return <FilterTag title={filterLabels[filter]} subTitle={tagList[0]?.name} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "Saved Filter") return tagList?.map((tags) => <FilterTag title="" subTitle={tags?.name} onRemove={() => removeSaveFilters()} />);
            if (filter === "multiCompanySearch") return tagList?.map((company) => <FilterTag title={filterLabels[filter]} subTitle={company?.name} onRemove={() => removeFilter(filter, company?.id, false)} />);
            return tagList?.map((tags) => tags.hide ? <></> : <FilterTag title={tags?.title} subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
          })}
          {/* Also render filters from pathKey for /pe, /vc, /re routes */}
          {(location.pathname.includes("/pe") || location.pathname.includes("/vc") || location.pathname.includes("/re")) && Object.keys(refineSearchFilters[pathKey] ?? {}).map((filter) => {
            tagList = refineSearchFilters[pathKey][filter];
            if ((tagList?.length ?? 0) === 0) return <></>;
            if (filter === "operator" || filter === "deals_operator") return null;
            if (filter === "yearFounded") return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "dealRange" || filter === "dealSize") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "fundRange" || filter === "fundSize") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "dealInvestorRange") return <FilterTag title={filterLabels[filter]} subTitle={`$${tagList[0]?.name} - $${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "returnMultiple") return <FilterTag title={filterLabels[filter]} subTitle={`${tagList[0]?.name} - ${tagList[1]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "investorSaleInipo") return <FilterTag subTitle={`${filterLabels[filter]} - ${tagList[0]?.name}`} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "chargeDate" || filter === "chargeAmount") return <FilterTag title={filterLabels[filter]} subTitle={tagList[0]?.name} onRemove={() => removeFilter(filter, 0, true)} />;
            if (filter === "Saved Filter") return tagList?.map((tags) => <FilterTag title="" subTitle={tags?.name} onRemove={() => removeSaveFilters()} />);
            if (filter === "multiCompanySearch") return tagList?.map((company) => <FilterTag title={filterLabels[filter]} subTitle={company?.name} onRemove={() => removeFilter(filter, company?.id, false)} />);
            return tagList?.map((tags) => tags.hide ? <></> : <FilterTag title={tags?.title} subTitle={tags?.name} onRemove={() => removeFilter(filter, tags?.id, false)} />);
          })}
        </div>
      </Drawer>
    </div>
  );
};

export default Tag;